app.factory('stopwatchService', ["$window", function ($window) {
	var service = this;

	service.stopwatches = {};

	service.serialize = function() {
		console.log("stopwatchService.serialize()");
		$window.localStorage.setItem("stopwatchService.stopwatches", JSON.stringify(service.stopwatches));
	}

	service.deserialize = function() {
		console.log("stopwatchService.deserialize()");
		var stopwatchesJson = $window.localStorage.getItem("stopwatchService.stopwatches");
		console.log(stopwatchesJson);
		if (stopwatchesJson) {
			try {
				service.stopwatches = JSON.parse(stopwatchesJson);
			} catch (e) {
				service.stopwatches = {};
			}
		} else {
			service.stopwatches = {};
		}
	}

	// get the current unix timestamp.
	service.timeUnix = function() {
		return parseInt((new Date()).getTime() / 1000.0);
	}

	service.getKey = function(args) {
		var key = "";
		for (var i = 0; i < args.length; i++) {
			key += args[i] + ":";
		}
		key = key.substring(0, key.length-1);
		return key;
	}

	// start the timer for key.
	service.start = function() {
		console.log("stopwatchService.start");
		var key = service.getKey(arguments);
		var entry = service.stopwatches[key];
		if (!entry) {
			entry = {start:0, stop:0, elapsed:0};
		}
		if (entry.start == 0) {
			entry.start = service.timeUnix();
			service.stopwatches[key] = entry;
			service.serialize();
		} else {
			console.log("stopwatchService: ignored attempt to register multiple start times for key " + key);
		}
	}

	// stop the timer for key.
	service.stop = function() {
		console.log("stopwatchService.stop");
		var key = service.getKey(arguments);
		var entry = service.stopwatches[key];
		if (!entry) {
			entry = {start:0, stop:0, elapsed:0};
		}
		if (entry.stop == 0) {
			entry.stop = service.timeUnix();
			entry.elapsed = entry.stop - entry.start;
			service.stopwatches[key] = entry;
			service.serialize();
		} else {
			console.log("stopwatchService: ignored attempt to register multiple stop times for key " + key);
		}
	}

	// get entry for key
	service.get = function() {
		var key = service.getKey(arguments);
		var entry = service.stopwatches[key];
		return entry;
	}

	service.deserialize();

	return service;
}]);